import { z } from 'my-zod'
import { subscriptionPlanModel } from './subscription-plan-model'
import { subscriptionPlanPriceModel } from './subscription-plan-price-model'

export const subscriptionPlanSystemView = subscriptionPlanModel
  .pick({
    id: true,
    name: true,
    metadata: true,
    isUnlimited: true,
    hasCoupon: true,
    isHidden: true,
    signupCreditBonus: true,
    startDate: true,
    endDate: true,
    billingProviderProductId: true,
    creditPurchasePrice: true
  })
  .augment({
    prices: subscriptionPlanPriceModel.array()
  })

export type subscriptionPlanSystemView = z.infer<typeof subscriptionPlanSystemView>
